/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-10
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import { modalFactory } from 'src/util/vueExtend';
 import SerialNumberLog from './serialNumberLog';
 
 export namespace CompleteLogVOI {
    export interface PropsI {
        mn?: number;
        name?: string;
    }
 }
 
@Component
class serialNumberLogModals extends Vue.Component<any> {
    visible: boolean = false;

    close() {
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    render(h) {
      return (
        <Modal
            title={'序列号日志'}
            width="800"
            footer-hide
            class-name="wqms-data-complete-modal"
            v-model={this.visible}
            mask-closable={false}
            on-on-cancel={this.close}
            >
            <SerialNumberLog />
        </Modal>
      );
    }
}


export default function serialNumberLogModal(): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<CompleteLogVOI.PropsI>(serialNumberLogModals)({
        });
        resolve();
    });
}
 